<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"    
    app
    color="primary"
    dark
    floating
    mobile-break-point="991"
    persistent
    :width="navwidth"
  >

    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template>

    <v-list-item two-line>
      <!-- <v-list-item-avatar color="white">
        <v-img
          :src="logo"
          height="34"
          contain
        />
      </v-list-item-avatar> -->

      <v-list-item-title class="body">
        <!-- JANUÁRIO ADV -->
        <v-img
          :src="logo"
          height="80"
          contain
        />
      </v-list-item-title>
    </v-list-item>     
    <v-list nav>  
      <v-divider class="mx-3 mb-3" />       
      <!-- <v-list-group :value="false" active-class="nav blue--text">
        <template v-slot:activator>
            <v-list-item-avatar>                                      
              <v-avatar v-show="!userAvatar || userAvatar === 'null'" color="blue">
                <span class="white--text headline">Hey</span>
              </v-avatar>
              <v-img v-if="userAvatar && userAvatar !== 'null'" :src="userAvatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-title>{{ userName }}</v-list-item-title>
        </template>
        <v-list-item :to="'/profile'" active-class="nav blue--text" style="padding-left: 30px;">
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
          <v-list-item-title style="font-size: 15px;" v-text="$vuetify.lang.t('$vuetify.drawer.editProfile')"></v-list-item-title>
        </v-list-item>        
      </v-list-group>
      <v-divider class="mx-3 mb-3" /> -->
      <v-list-item
        v-for="(link, i) in links"
        :key="i"
        :to="link.to"
        active-class="white--text"
        :class="{'px-4' : isTabletSize}"
      >
        <v-list-item-action :title="link.text">
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="link.text" v-if="!isTabletSize" />
      </v-list-item>
    </v-list>

    <!-- <template v-slot:append>
      <v-list nav>
        <v-list-item to="/logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-title class="font-weight-light">
            {{ $vuetify.lang.t('$vuetify.drawer.logout') }}
          </v-list-item-title>
        </v-list-item>
      </v-list> 
    </template> -->
  </v-navigation-drawer>
</template>

<script>
// Utilities  
  import { mapMutations } from 'vuex'


  export default {
    props: {
      opened: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
        logo: require("@/assets/logo.png"),
    }),  

    computed: {            
      inputValue: {
        get () {
          return this.$store.state.app.drawer && this.isAuthenticated
        },
        set (val) {                              
          this.setDrawer(val)
        }
      },
      navwidth() {        
        if (this.isAuthenticated) {
          if (this.isTabletSize)
            return 70;
          else 
            return 260;
        }
        return 0;
      },
      links() {
          return [
              { to: '/', icon: 'mdi-view-dashboard', text: 'Home' },
              { to: '/boletos', icon: 'mdi-cash-multiple', text: 'Boletos' },
              { to: '/usuarios', icon: 'mdi-account', text: 'Usuários' },                            
              { to: '/solicitacoes', icon: 'mdi-book-open-outline', text: 'Solicitações' },
              { to: '/documentos', icon: 'mdi-image', text: 'Documentos' },
              { to: '/notificacoes', icon: 'mdi-bell-alert', text: 'Notificações' },
          ]
      }
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer'])      
    }
  }
</script>
